import { assign } from '@xstate/immer';
import { send, StateNodeConfig } from 'xstate';
import {
  SignUpFlowEvents,
  SignUpFlowEventsTypes,
} from './signUpMachineEventTypes';
import {
  SignUpFlowContext,
  SignUpFlowStatesSchema,
  SIGN_UP_FLOW_STATES_NAME,
} from './signUpMachineTypes';

const isActiveStep = (context: SignUpFlowContext, step: number) => {
  return context.activeStep === step;
};

const setNextStep = send(SignUpFlowEventsTypes.SET_NEXT_STEP, { delay: 800 });

export const initState: StateNodeConfig<
  SignUpFlowContext,
  SignUpFlowStatesSchema['states'][SIGN_UP_FLOW_STATES_NAME.INIT],
  SignUpFlowEvents
> = {
  on: {
    '': [
      {
        target: [SIGN_UP_FLOW_STATES_NAME.WELCOME],
        cond: cont => isActiveStep(cont, 0),
      },
      {
        target: [SIGN_UP_FLOW_STATES_NAME.BILLING],
        cond: cont => isActiveStep(cont, 1),
      },
    ],
  },
};

export const welcomeState: StateNodeConfig<
  SignUpFlowContext,
  SignUpFlowStatesSchema['states'][SIGN_UP_FLOW_STATES_NAME.WELCOME],
  SignUpFlowEvents
> = {
  invoke: {
    id: 'updateCompany',
    src: 'updateCompanyService',
  },
  on: {
    [SignUpFlowEventsTypes.START]: {
      target: [SIGN_UP_FLOW_STATES_NAME.BILLING],
      actions: [
        assign((context, event) => {
          context.activeStep = 1;
          const {
            name,
            businessEmail,
            website,
            phoneNumber,
            goal,
            jobRole,
            clientsCharge,
          } = event.data;

          if (context.company) {
            const updatedFields = {
              name,
              businessEmail,
              website,
              phoneNumber,
              jobRole,
              clientsCharge,
              goal,
            };
            context.company = {
              ...context.company,
              ...updatedFields,
            };
          }
        }),
        setNextStep,
      ],
    },
    [SignUpFlowEventsTypes.SET_NEXT_STEP]: [
      {
        target: [SIGN_UP_FLOW_STATES_NAME.BILLING],
        actions: assign(context => {
          context.activeStep = 1;
        }),
      },
    ],
  },
};

export const billingState: StateNodeConfig<
  SignUpFlowContext,
  SignUpFlowStatesSchema['states'][SIGN_UP_FLOW_STATES_NAME.BILLING],
  SignUpFlowEvents
> = {
  invoke: {
    id: 'updateCompany',
    src: 'updateCompanyService',
  },
  on: {
    [SignUpFlowEventsTypes.SELECT_BILLING_PLAN]: {
      actions: [
        assign(context => {
          context.activeStep = 1;
        }),
      ],
    },
  },
};

export const redirectState: StateNodeConfig<
  SignUpFlowContext,
  SignUpFlowStatesSchema['states'][SIGN_UP_FLOW_STATES_NAME.REDIRECT],
  SignUpFlowEvents
> = {
  invoke: {
    id: 'redirect',
    src: 'redirectService',
    onDone: {
      target: [SIGN_UP_FLOW_STATES_NAME.WELCOME],
      actions: assign(context => {
        context.company = undefined;
      }),
    },
  },
};
